import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { SelectionListItem } from "../../../../../Forms/SelectionListItem";
import { minutesAsMilliSeconds } from "../../../../../Utils/time";
import { PlantType } from "../../../../../Plants/PlantType";
import { ttProtectionPlantForPlantTypesAndAllEdcs } from "../ttProtectionQueryKey";

type FetchPlantGsdbForPlantTypesProps = {
  url: string;
  plantTypes: PlantType[];
};

export const useFetchPlantGsdbForPlantTypes = ({
  url,
  plantTypes,
}: FetchPlantGsdbForPlantTypesProps) => {
  return useQuery<SelectionListItem<string>[], Error>({
    queryKey: ttProtectionPlantForPlantTypesAndAllEdcs,
    staleTime: minutesAsMilliSeconds(10),
    cacheTime: minutesAsMilliSeconds(20),
    queryFn: () => fetchPlantsByPlantTypes({ url, plantTypes }),
    onError: () => {
      toast.error("An error occurred when retrieving the Plant GSDBs");
    },
  });
};

const fetchPlantsByPlantTypes = async ({ url, plantTypes }: FetchPlantGsdbForPlantTypesProps) => {
  const { data: items } = await axios.post<SelectionListItem<string>[]>(url, plantTypes);
  return items;
};
